var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._l((_vm.data),function(team,tid){return _c('v-container',{key:tid},[(team !== undefined)?[_c('team-users',{attrs:{"team":team,"team_stat":_vm.data_stat[team.id],"team_user_action":_vm.team_user_action}})]:_vm._e()],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }